<template>
	<div class="content">
		<div>
			<div class="float-l">
				<el-page-header @back="goBack" :content="id ? '编辑学员' : '新增学员'"></el-page-header>
			</div>
			<div class="float-r" v-if="id">
				<el-button size="small" type="primary" v-if="!isEidt" @click="isEidt = true">编辑学员</el-button>
				<el-button size="small" v-if="isEidt" @click="isEidt = false">返回详情</el-button>
			</div>
		</div>
		<div style="clear: both;"></div>
		<div class="mt30">
			<el-form
				ref="ruleFormRef"
				:model="ruleForm"
				:rules="rules"
				label-width="92px"
				class="bordered-form"
				size="small"
			>
				<el-divider content-position="center">学生信息</el-divider>
				<el-row>
					<el-col :span="4">
						<el-form-item label-width="60px" label="编号：" prop="student.code">
							<el-input v-if="!id || (id && isEidt)" v-model="ruleForm.student.code"/>
							<span v-if="id && !isEidt">{{ruleForm1.student.code}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="学生姓名：" prop="student.name">
							<el-input v-if="!id || (id && isEidt)" v-model="ruleForm.student.name" />
							<span v-if="id && !isEidt">{{ruleForm1.student.name}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="手机号：" prop="student.phone">
							<el-input v-if="!id || (id && isEidt)" maxlength="11" v-model="ruleForm.student.phone" />
							<span v-if="id && !isEidt">{{ruleForm1.student.phone}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="家长姓名：" prop="student.parentName">
							<el-input v-if="!id || (id && isEidt)" v-model="ruleForm.student.parentName" />
							<span v-if="id && !isEidt">{{ruleForm1.student.parentName}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="手机号：" prop="student.parentPhone">
							<el-input v-if="!id || (id && isEidt)" maxlength="11" v-model="ruleForm.student.parentPhone" />
							<span v-if="id && !isEidt">{{ruleForm1.student.parentPhone}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="!id || (id && isEidt)" v-for="(item,index) in ruleForm.backgrounds" :key="item.index">
					<el-col :span="4">
						<el-form-item label-width="60px" label="学历：" :prop="`backgrounds[${index}].degreeStatus`" :rules="rules.degreeStatus">
							<el-select v-model="item.degreeStatus" placeholder="请选择学历">
								<el-option label="专科" value="专科"></el-option>
								<el-option label="本科" value="本科"></el-option>
								<el-option label="硕士研究生" value="硕士研究生"></el-option>
								<el-option label="博士研究生" value="博士研究生"></el-option>
								<el-option label="本硕连读" value="本硕连读"></el-option>
								<el-option label="本硕博连读" value="本硕博连读"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label-width="60px" label="学制：" :prop="`backgrounds[${index}].degreeYear`" :rules="rules.degreeYear">
							<el-select v-model="item.degreeYear" placeholder="请选择学制">
								<el-option label="3年" value="3年"></el-option>
								<el-option label="4年" value="4年"></el-option>
								<el-option label="5年" value="5年"></el-option>
								<el-option label="8年" value="8年"></el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="入学年份：" :prop="`backgrounds[${index}].attendanceYear`" :rules="rules.attendanceYear">
							<el-input-number style="width: 106px;" :controls="false" v-model="item.attendanceYear" controls-position="right" :min="1900" :max="2100"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="就读院校：" :prop="`backgrounds[${index}].schoolName`" :rules="rules.schoolName">
							<el-input v-model="item.schoolName" />
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label-width="60px" label="专业：" :prop="`backgrounds[${index}].major`" :rules="rules.major">
							<el-input v-model="item.major" />
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态：" :prop="`backgrounds[${index}].status`" :rules="rules.status" label-width="50px">
							<el-select v-model="item.status" placeholder="请选择学制">
								<el-option label="在读" value="在读"></el-option>
								<el-option label="保留学籍" value="保留学籍"></el-option>
								<el-option label="毕业" value="毕业"></el-option>
								<el-option label="肄业" value="肄业"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="1" style="line-height: 30px;">
						<i class="el-icon-plus pointer" v-if="index==0" style="color: green;margin-left: 15px;" @click="addSchoolItem"></i>
						<i class="el-icon-minus pointer" v-if="index!=0" style="color: red;margin-left: 15px;" @click="removeSchoolItem(index)"></i>
					</el-col>
				</el-row>
				<el-row v-if="id && !isEidt" v-for="(item,index) in ruleForm1.backgrounds" :key="item.index">
					<el-col :span="3">
						<el-form-item label-width="60px" label="学历：" :prop="`backgrounds[${index}].degreeStatus`" :rules="rules.degreeStatus">
							<span>{{item.degreeStatus}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label-width="60px" label="学制：" :prop="`backgrounds[${index}].degreeYear`" :rules="rules.degreeYear">
							<span>{{item.degreeYear}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="入学年份：" :prop="`backgrounds[${index}].attendanceYear`" :rules="rules.attendanceYear">
							<span>{{item.attendanceYear}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="就读院校：" :prop="`backgrounds[${index}].schoolName`" :rules="rules.schoolName">
							<span>{{item.schoolName}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label-width="60px" label="专业：" :prop="`backgrounds[${index}].major`" :rules="rules.major">
							<span>{{item.major}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态：" :prop="`backgrounds[${index}].status`" :rules="rules.status" label-width="50px">
							<span>{{item.status}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="center">选科及成绩</el-divider>
				<el-row>
					<el-col :span="4">
						<el-form-item label-width="60px" label="选科：" prop="student.subjectType">
							<el-input v-if="!id || (id && isEidt)" v-model="ruleForm.student.subjectType" />
							<span v-if="id && !isEidt">{{ruleForm1.student.subjectType}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="总成绩：" prop="student.totalGrade">
							<el-input-number v-if="!id || (id && isEidt)" :controls="false" v-model="ruleForm.student.totalGrade" controls-position="right" :min="0"></el-input-number>
							<span v-if="id && !isEidt">{{ruleForm1.student.totalGrade}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="英语成绩：" prop="student.englishGrade">
							<el-input-number v-if="!id || (id && isEidt)" :controls="false" v-model="ruleForm.student.englishGrade" controls-position="right" :min="0"></el-input-number>
							<span v-if="id && !isEidt">{{ruleForm1.student.englishGrade}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="数学成绩：" prop="student.mathGrade">
							<el-input-number v-if="!id || (id && isEidt)" :controls="false" v-model="ruleForm.student.mathGrade" controls-position="right" :min="0"></el-input-number>
							<span v-if="id && !isEidt">{{ruleForm1.student.mathGrade}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="语文成绩：" prop="student.chineseGrade">
							<el-input-number v-if="!id || (id && isEidt)" :controls="false" v-model="ruleForm.student.chineseGrade" controls-position="right" :min="0"></el-input-number>
							<span v-if="id && !isEidt">{{ruleForm1.student.chineseGrade}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="center">服务项目</el-divider>
				<el-row>
					<el-col :span="24" style="line-height: 30px; text-align: center;">
						<el-checkbox-group v-if="!id || (id && isEidt)" v-model="serviceList">
							<el-checkbox label="高考志愿填报" name="type" />
							<el-checkbox label="大一陪跑服务" name="type" />
							<el-checkbox label="公职就业VIP全流程陪伴服务" name="type" />
							<el-checkbox label="公职类考试地面班" name="type" />
							<el-checkbox label="考研规划" name="type" />
						</el-checkbox-group>
						<span v-if="id && !isEidt">{{ (ruleForm1.student.service || '无').split(',').filter(item => item.trim() !== '').join('、') }}</span>
					</el-col>
				</el-row>
				<el-divider content-position="center">身份及荣誉</el-divider>
				<el-row>
					<el-col :span="24" v-if="!id || (id && isEidt)">
						<el-form-item label-width="135px" label="最高学历阶段学生干部身份(可多选)：" prop="student.studentCadre">
							<div class="rongyu">
								<el-checkbox-group  v-model="studentCadreList" @change="handleCadreStatusChange">
									<el-checkbox label="班长" name="type" />
									<el-checkbox label="团支书" name="type" />
									<el-checkbox label="其他班委" name="type" />
									<el-checkbox label="学生会主席、副主席" name="type" />
									<el-checkbox label="学生会部长、副部长" name="type" />
									<el-checkbox label="其他学生干部" name="type" />
									<el-checkbox label="无" name="type" />
								</el-checkbox-group>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="id && !isEidt">
						<el-form-item label-width="200px" label="最高学历阶段学生干部身份：" prop="student.studentCadre">
							<div>
								<span>{{ (ruleForm1.student.studentCadre || '无').split(',').filter(item => item.trim() !== '').join('、') }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="!id || (id && isEidt)">
						<el-form-item label-width="135px" label="政治面貌：" prop="student.politicalStatus">
							<div class="rongyu">
								<el-radio-group v-model="ruleForm.student.politicalStatus">
									<el-radio label="中共党员（或预备党员）" />
									<el-radio label="共青团员" />
									<el-radio label="群众" />
								</el-radio-group>
							</div>	
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="id && !isEidt">
						<el-form-item label-width="200px" label="政治面貌：" prop="student.politicalStatus">
							<div>	
								<span>{{ (ruleForm1.student.politicalStatus || '无').split(',').filter(item => item.trim() !== '').join('、') }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="!id || (id && isEidt)">
						<el-form-item label-width="135px" label="最高学历阶段荣誉及奖学金(可多选)：" prop="student.scholarship">
							<div class="rongyu">
								<el-checkbox-group v-model="scholarshipList" @change="handleHonorChange">
									<el-checkbox label="校级优秀学生干部" name="type" />
									<el-checkbox label="校级三好学生" name="type" />
									<el-checkbox label="校级一等奖学金" name="type" />
									<el-checkbox label="国家奖学金" name="type" />
									<el-checkbox label="国家励志奖学金" name="type" />
									<el-checkbox label="省级奖学金" name="type" />
									<el-checkbox label="无" name="type" />
								</el-checkbox-group>
							</div>	
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="id && !isEidt">
						<el-form-item label-width="200px" label="最高学历阶段荣誉及奖学金：" prop="student.scholarship">
							<div>
								<span>{{ (ruleForm1.student.scholarship || '无').split(',').filter(item => item.trim() !== '').join('、') }}</span>
							</div>	
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="!id || (id && isEidt)" >
						<el-form-item label-width="135px" label="主要证书(可多选)：" prop="student.certification">
							<div class="rongyu">
								<el-checkbox-group v-model="certificationList" @change="handleCertificateChange">
									<el-checkbox label="通过国家司法考试" name="type" />
									<el-checkbox label="通过国家统一法律职业资格考试" name="type" />
									<el-checkbox label="取得国家法律职业资格证书" name="type" />
									<el-checkbox label="无" name="type" />
								</el-checkbox-group>
							</div>	
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="id && !isEidt">
						<el-form-item label-width="200px" label="主要证书：" prop="student.certification">
							<div>
								<span>{{ (ruleForm1.student.certification || '无').split(',').filter(item => item.trim() !== '').join('、') }}</span>
							</div>	
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16" v-if="!id || (id && isEidt)">
						<el-form-item label-width="135px" label="英语四六级成绩(可多选)：" prop="student.englishLevel">
							<div class="rongyu">
								<el-checkbox-group v-model="englishLevelList" @change="handleEnglishLevelChange">
									<el-checkbox label="未参加或未通过" name="type" />
									<el-checkbox label="通过英语四级" name="type" />
									<el-checkbox label="通过英语六级" name="type" />
								</el-checkbox-group>
							</div>	
						</el-form-item>
					</el-col>
					<el-col :span="4" class="mt20" v-if="!id || (id && isEidt)">
						<el-form-item label="四级成绩：" prop="student.englishLevel4Grade">
							<el-input-number style="width: 106px;" :controls="false" v-model="ruleForm.student.englishLevel4Grade" controls-position="right" :min="0" :disabled="!englishLevelList.includes('通过英语四级')"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="4" class="mt20" v-if="!id || (id && isEidt)">
						<el-form-item label="六级成绩：" prop="student.englishLevel6Grade">
							<el-input-number style="width: 106px;" :controls="false" v-model="ruleForm.student.englishLevel6Grade" controls-position="right" :min="0" :disabled="!englishLevelList.includes('通过英语六级')"></el-input-number>
						</el-form-item>
					</el-col>

					<el-col :span="16" v-if="id && !isEidt">
						<el-form-item label-width="200px" label="英语四六级成绩：" prop="student.englishLevel">
							<div>
								<span>
									{{ (ruleForm1.student.englishLevel || '无').split(',').filter(item => item.trim() !== '').join('、') }}
								</span>
								<span style="margin-left: 20px;" v-if="ruleForm1.student.englishLevel.indexOf('通过英语四级')>-1">
									<span style="color: #606266;">四级成绩：</span>{{ ruleForm1.student.englishLevel4Grade }}
								</span>
								<span style="margin-left: 20px;" v-if="ruleForm1.student.englishLevel.indexOf('通过英语六级')>-1">
									<span style="color: #606266;">六级成绩：</span>{{ ruleForm1.student.englishLevel6Grade }}
								</span>
							</div>	
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="center">规划跟踪沟通痕迹</el-divider>
				<el-row v-if="!id || (id && isEidt)" v-for="(item,index) in ruleForm.communications" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="沟通日期：" :prop="`communications[${index}].communicationDate`" :rules="rules.communicationDate">
							<el-date-picker
								v-model="item.communicationDate"
								placeholder="沟通日期"
								type="date"
								value-format="timestamp"
								style="width: 100%"
							/>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label-width="110px" label="沟通内容摘要：" :prop="`communications[${index}].context`" :rules="rules.context">
							<el-input v-model="item.context" type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
					<el-col :span="1" style="line-height: 30px;">
						<i class="el-icon-plus pointer" v-if="index==0" style="color: green;margin-left: 15px;" @click="addCommunicationItem"></i>
						<i class="el-icon-minus pointer" v-if="index!=0" style="color: red;margin-left: 15px;" @click="removeCommunicationItem(index)"></i>
					</el-col>
				</el-row>
				<el-row v-if="id && !isEidt" v-for="(item,index) in ruleForm1.communications" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="沟通日期：" :prop="`communications[${index}].communicationDate`" :rules="rules.communicationDate">
							<span>{{ formatTime(item.communicationDate) || '-' }}</span>
						</el-form-item>
					</el-col>
					<el-col :span="17">
						<el-form-item label-width="110px" label="沟通内容摘要：" :prop="`communications[${index}].context`" :rules="rules.context">
							<el-input v-model="item.context" disabled type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="center">下一步规划目标</el-divider>
				<el-row>
					<el-col :span="24" class="xiayibu">
						<el-form-item label-width="135px" label="提示：" prop="advice">
							<el-input :value="getAdviceFlag?'加载中。。。':ruleForm.advice"  :rows="2" type="textarea" disabled/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="!id || (id && isEidt)" v-for="(item,index) in ruleForm.targets" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="目标设立日期：" :prop="`targets[${index}].targetCreatedTime`" :rules="rules.targetCreatedTime">
							<el-date-picker
								v-model="item.targetCreatedTime"
								placeholder="目标设立日期"
								type="date"
								value-format="timestamp"
								style="width: 100%"
							/>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label-width="110px" label="目标具体内容：" :prop="`targets[${index}].target`" :rules="rules.target">
							<el-input v-model="item.target" type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label-width="110px" label="目标实现情况：" :prop="`targets[${index}].targetStatus`" :rules="rules.targetStatus">
							<el-input v-model="item.targetStatus" type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
					<el-col :span="1" style="line-height: 30px;">
						<i class="el-icon-plus pointer" v-if="index==0" style="color: green;margin-left: 15px;" @click="addNextTargetItem"></i>
						<i class="el-icon-minus pointer" v-if="index!=0" style="color: red;margin-left: 15px;" @click="removeNextTargetItem(index)"></i>
					</el-col>
				</el-row>
				<el-row v-if="id && !isEidt" v-for="(item,index) in ruleForm1.targets" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="目标设立日期：" :prop="`targets[${index}].targetCreatedTime`" :rules="rules.targetCreatedTime">
							<span>{{ formatTime(item.targetCreatedTime) || '-' }}</span>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label-width="110px" label="目标具体内容：" :prop="`targets[${index}].target`" :rules="rules.target">
							<el-input v-model="item.target" disabled type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
					<el-col :span="7">
						<el-form-item label-width="110px" label="目标实现情况：" :prop="`targets[${index}].targetStatus`" :rules="rules.targetStatus">
							<el-input v-model="item.targetStatus" disabled type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="center">其他备注</el-divider>
				<el-row v-if="!id || (id && isEidt)" v-for="(item,index) in ruleForm.notes" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="备注日期：" :prop="`notes[${index}].noteCreatedTime`" :rules="rules.noteCreatedTime">
							<el-date-picker
								v-model="item.noteCreatedTime"
								placeholder="备注日期"
								type="date"
								value-format="timestamp"
								style="width: 100%"
							/>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label-width="110px" label="备注具体内容：" :prop="`notes[${index}].note`" :rules="rules.note">
							<el-input v-model="item.note" type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
					<el-col :span="1" style="line-height: 30px;">
						<i class="el-icon-plus pointer" v-if="index==0" style="color: green;margin-left: 15px;" @click="addOtherRemarksItem"></i>
						<i class="el-icon-minus pointer" v-if="index!=0" style="color: red;margin-left: 15px;" @click="removeOtherRemarksItem(index)"></i>
					</el-col>
				</el-row>
				<el-row v-if="id && !isEidt" v-for="(item,index) in ruleForm1.notes" :key="item.index">
					<el-col :span="7">
						<el-form-item label-width="135px" label="备注日期：" :prop="`notes[${index}].noteCreatedTime`" :rules="rules.noteCreatedTime">
							<span>{{ formatTime(item.noteCreatedTime) || '-' }}</span>
						</el-form-item>
					</el-col>
					<el-col :span="17">
						<el-form-item label-width="110px" label="备注具体内容：" :prop="`notes[${index}].note`" :rules="rules.note">
							<el-input v-model="item.note" disabled type="textarea" :autosize="{ minRows: 1, maxRows: 3}"/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-form-item style="text-align: right;" v-if="!id || (id && isEidt)">
					<el-button @click="goBack">返回</el-button>
					<el-button type="primary" @click="submitForm" :disabled="disabled">保存</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'

export default {
	name: 'addStudent',
	data(){
		return{
			getAdviceFlag: false, // 是否获取下一步规划目标
			id: this.$route.query.id,
			isEidt: false, // 是否是编辑
			disabled: false, // 保存按钮
			list: [],
			ruleForm: {
				student:{
					code: '', // 编号
					name: '', // 学生姓名
					phone: '', // 学生手机号
					parentName: '', // 家长姓名
					parentPhone: '', // 家长手机号
					subjectType: '', // 选科类型
					totalGrade: '', // 高考总成绩
					chineseGrade: '', // 高考语文成绩
					mathGrade: '', // 高考数学成绩
					englishGrade: '', // 高考英语成绩
					service: '', // 服务项目
					studentCadre: '', // 最高学历干部身份
					politicalStatus: '', // 政治面貌
					scholarship: '', // 荣誉
					certification: '', // 证书
					englishLevel: '', // 英语水平等级
					englishLevel4Grade: '', // 英语四级成绩
					englishLevel6Grade: '', // 英语六级成绩
				},
				backgrounds:[{ // 就读学校信息List
					degreeStatus: '', // 学历
					degreeYear: '', // 学制
					attendanceYear: new Date().getFullYear(), // 入学年份
					schoolName: '', // 就读院校
					major: '', // 专业
					status: '', // 状态
				}],
				communications:[{
					communicationDate: null, // 沟通日期
					context: '', // 沟通内容摘要
				}],
				targets: [{
					targetCreatedTime: null, // 目标设立日期
					target: '', // 目标具体内容
					targetStatus: '', // 目标实现情况
				}],
				notes:[{
					noteCreatedTime: null, // 备注日期
					note: '', // 备注
				}],
				advice:'', // 下一步规划目标
			},
			serviceList: [], // 服务项目
			studentCadreList: [], // 最高学历干部身份
			scholarshipList: [], // 荣誉
			certificationList: [], // 证书
			englishLevelList: [], // 英语水平等级


			ruleForm1: {
				student:{
					code: '', // 编号
					name: '', // 学生姓名
					phone: '', // 学生手机号
					parentName: '', // 家长姓名
					parentPhone: '', // 家长手机号
					subjectType: '', // 选科类型
					totalGrade: '', // 高考总成绩
					chineseGrade: '', // 高考语文成绩
					mathGrade: '', // 高考数学成绩
					englishGrade: '', // 高考英语成绩
					service: '', // 服务项目
					studentCadre: '', // 最高学历干部身份
					politicalStatus: '', // 政治面貌
					scholarship: '', // 荣誉
					certification: '', // 证书
					englishLevel: '', // 英语水平等级
					englishLevel4Grade: '', // 英语四级成绩
					englishLevel6Grade: '', // 英语六级成绩
				},
				backgrounds:[{ // 就读学校信息List
					degreeStatus: '', // 学历
					degreeYear: '', // 学制
					attendanceYear: new Date().getFullYear(), // 入学年份
					schoolName: '', // 就读院校
					major: '', // 专业
					status: '', // 状态
				}],
				communications:[{
					communicationDate: null, // 沟通日期
					context: '', // 沟通内容摘要
				}],
				targets: [{
					targetCreatedTime: null, // 目标设立日期
					target: '', // 目标具体内容
					targetStatus: '', // 目标实现情况
				}],
				notes:[{
					noteCreatedTime: null, // 备注日期
					note: '', // 备注
				}],
				advice:'', // 下一步规划目标
			},
			serviceList1: [], // 服务项目
			studentCadreList1: [], // 最高学历干部身份
			scholarshipList1: [], // 荣誉
			certificationList1: [], // 证书
			englishLevelList1: [], // 英语水平等级

			rules: {
				// 'student.code': [{ required: true, message: '请输入编号', trigger: 'blur' },],
				'student.name': [{ required: true, message: '请输入学生姓名', trigger: 'blur' },],
				'student.phone': [{ required: true, message: '请输入学生手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
				],
				'student.parentName': [{ required: true, message: '请输入家长姓名', trigger: 'blur' },],
				'student.parentPhone': [{ required: true, message: '请输入家长手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
				],
				degreeStatus: [{ required: true, message: '请选择学历', trigger: 'change' },],
				attendanceYear: [{ required: true, message: '请输入入学年份', trigger: 'blur' },
					// 新增：限制4位数字（长度4位，且为0-9的数字）
					{ pattern: /^\d{4}$/, message: '请输入4位数字的年份（如2023）', trigger: 'blur' }
				],
				schoolName: [{ required: true, message: '请输入就读院校', trigger: 'blur' },],
				major: [{ required: true, message: '请输入专业', trigger: 'blur' },],
				'student.studentCadre': [{ required: true, message: '请选择最高学历阶段学生干部身份', trigger: 'change' },],
				'student.politicalStatus': [{ required: true, message: '请选择政治面貌', trigger: 'change' },],
				'student.scholarship': [{ required: true, message: '请选择最高学历阶段荣誉及奖学金', trigger: 'change' },],
				'student.certification': [{ required: true, message: '请选择主要证书', trigger: 'change' },],
				'student.englishLevel': [{ required: true, message: '请选择英语水平等级', trigger: 'change' },],
			},
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		if(this.$route.query.id){
			this.getData();
		}
	},

	// 新增：侦听器，监听目标字段变化
	watch: {
		// 1. 监听政治面貌（直接绑定的字段）
		'ruleForm.student.politicalStatus': {
			handler(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					this.getAdvice(); // 调用后台接口
				}
			},
			immediate: false // 首次加载不触发
		},
		// 2. 监听学生干部身份（数组变化）
		studentCadreList: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					this.getAdvice();
				}
			},
			deep: true // 深度监听数组内部元素变化
		},
		// 3. 监听荣誉奖学金（数组变化）
		scholarshipList: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					this.getAdvice();
				}
			},
			deep: true
		},
		// 4. 监听证书（数组变化）
		certificationList: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					this.getAdvice();
				}
			},
			deep: true
		},
		// 新增：监听 backgrounds 数组的变化（深度监听）
		'ruleForm.backgrounds': {
			handler(newVal, oldVal) {
				// 排除初始化时的空数组变化（可选，根据业务需求调整）
				if (newVal && newVal.length > 0) {
				this.getAdvice();
				}
			},
			deep: true, // 必须开启深度监听，捕获数组元素的增删、属性修改
			immediate: false // 首次加载不触发
		}
	},

	methods: {
		// 新增：通用的后台接口调用方法（根据实际需求修改接口地址和参数）
		getAdvice() {
			if(this.getAdviceFlag){
				return;
			}
			this.getAdviceFlag = true;
			setTimeout(()=>{
				// 发送请求
				this.ruleForm.student.service = this.serviceList.join(',');
				// 调用后台接口（示例：POST请求，需替换为实际接口地址）
				this.$http.post('/api/webs/student2/getAdvice', this.ruleForm)
					.then(response => {
					if (response.code === 'S000001') {
						// console.log('字段变化，接口调用成功', response.data);
						// 可选：提示用户
						// this.$message.success('数据同步成功');
						this.ruleForm.advice = response.data.advice;
						this.getAdviceFlag = false;
					}})
					.catch(error => {
						this.getAdviceFlag = false;
						console.error('接口调用失败', error);
						// this.$message.error('数据同步失败，请重试');
					});
			},3000);
		},
		// 时间戳转时间格式（timestamp 为毫秒级时间戳）
		formatTime(timestamp) {
			if (!timestamp) return ''; // 处理空值
			
			// 时间戳可能是秒级（10位），需转为毫秒级（13位）
			if (timestamp.toString().length === 10) {
				timestamp = timestamp * 1000;
			}
			
			const date = new Date(timestamp);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补0
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			
			// 返回格式：YYYY-MM-DD HH:MM:SS（可按需调整）
			// return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			return `${year}-${month}-${day}`;
		},
		getData(){
			this.$http.post('/api/webs/student2/getById',{id:this.$route.query.id})
			.then(response => {
				let res = response
				this.ruleForm = res.data
				this.serviceList = res.data.student.service.split(',')
				this.studentCadreList = res.data.student.studentCadre.split(',')
				this.scholarshipList = res.data.student.scholarship.split(',')
				this.certificationList = res.data.student.certification.split(',')
				this.englishLevelList = res.data.student.englishLevel.split(',')


				this.ruleForm1 = JSON.parse(JSON.stringify(res.data));
				this.serviceList1 = this.ruleForm1.student.service.split(',')
				this.studentCadreList1 = this.ruleForm1.student.studentCadre.split(',')
				this.scholarshipList1 = this.ruleForm1.student.scholarship.split(',')
				this.certificationList1 = this.ruleForm1.student.certification.split(',')
				this.englishLevelList1 = this.ruleForm1.student.englishLevel.split(',')
				console.log(111112222,this.ruleForm);
			})
			.catch(error => {
				console.error(error)
			})
		},
		getList(){
			this.$http.get('/api/webs/dict/list')
			.then(response => {
				let res = response
				this.list = res.data
				this.ruleForm.student.studentCadre = this.studentCadreList.join(',');
			})
			.catch(error => {
				console.error(error)
			})
		},
		submitForm(){
			if(!this.token) return EventBus.$emit('show-login', true)
			console.log(11111111,this.ruleForm);
			this.ruleForm.student.service = this.serviceList.join(',');

			const method = !this.$route.query.id ? '/api/webs/student2/add' : '/api/webs/student2/set'

			this.$refs.ruleFormRef.validate((valid) => {
			    if (valid) {
					this.disabled = true
					this.$http.post(method, this.ruleForm)
					.then(response => {
						if(response.code != 'S000001') return
						let res = response
						this.disabled = false
						this.$message({ message: !this.$route.query.id ? '新增学员成功' : '编辑学员成功', type: 'success' })
						setTimeout(() => {
							// this.goBack(); // 保存成功后返回上一页
							this.getData();
							this.isEidt = false;
						}, 1000);
					})
					.catch(error => {
						console.error(error)
						this.disabled = false
					})
			    } else {
			        console.log('error submit!!');
			        return false;
			    }
			});
		},
		toPage(e){
			this.$router.push(e)
		},
		goBack(){
			this.$router.go(-1)
		},
		// 添加学校信息项
		addSchoolItem() {
			this.ruleForm.backgrounds.push({
				degreeStatus: '',
				degreeYear: '',
				attendanceYear: new Date().getFullYear(),
				schoolName: '',
				major: '',
				status: ''
			});
		},
		// 删除学校信息项
		removeSchoolItem(index) {
			if (this.ruleForm.backgrounds.length <= 1) {
				this.$message.warning('至少保留一项学校信息');
				return;
			}
			this.ruleForm.backgrounds.splice(index, 1);
		},
		// 添加沟通信息项
		addCommunicationItem() {
			this.ruleForm.communications.push({
				communicationDate: null,
				context: '',
			});
		},
		// 删除沟通信息项
		removeCommunicationItem(index) {
			if (this.ruleForm.communications.length <= 1) {
				this.$message.warning('至少保留一项沟通信息');
				return;
			}
			this.ruleForm.communications.splice(index, 1);
		},
		// 添加目标信息项
		addNextTargetItem() {
			this.ruleForm.targets.push({
				targetCreatedTime: null,
				target: '',
				targetStatus: '',
			});
		},
		// 删除目标信息项
		removeNextTargetItem(index) {
			if (this.ruleForm.targets.length <= 1) {
				this.$message.warning('至少保留一项目标信息');
				return;
			}
			this.ruleForm.targets.splice(index, 1);
		},
		// 添加备注信息项
		addOtherRemarksItem() {
			this.ruleForm.notes.push({
				noteCreatedTime: null,
				note: '',
			});
		},
		// 删除备注信息项
		removeOtherRemarksItem(index) {
			if (this.ruleForm.notes.length <= 1) {
				this.$message.warning('至少保留一项备注信息');
				return;
			}
			this.ruleForm.notes.splice(index, 1);
		},
		// 处理干部身份选择变化
		handleCadreStatusChange(values) {
			// 检查是否选中了"无"
			const hasNone = values[values.length-1].includes('无');
			if (hasNone) {
				// 如果选中了"无"，只保留"无"这一项
				this.studentCadreList = ['无'];
			} else {
				// 未选中"无"，过滤掉可能残留的"无"（防止之前选中后未清除）
    			this.studentCadreList = values.filter(item => item !== '无');
			}
			this.ruleForm.student.studentCadre = this.studentCadreList.join(',');
			this.$refs.ruleFormRef.validateField('student.studentCadre');
		},
		// 处理荣誉选择变化
		handleHonorChange(values) {
			// 检查是否选中了"无"
			const hasNone = values[values.length-1].includes('无');
			if (hasNone) {
				// 如果选中了"无"，只保留"无"这一项
				this.scholarshipList = ['无'];
			} else {
				// 未选中"无"，过滤掉可能残留的"无"（防止之前选中后未清除）
    			this.scholarshipList = values.filter(item => item !== '无');
			}
			this.ruleForm.student.scholarship = this.scholarshipList.join(',');
			this.$refs.ruleFormRef.validateField('student.scholarship');
		},
		// 处理证书选择变化
		handleCertificateChange(values) {
			// 检查是否选中了"无"
			const hasNone = values[values.length-1].includes('无');
			if (hasNone) {
				// 如果选中了"无"，只保留"无"这一项
				this.certificationList = ['无'];
			} else {
				// 未选中"无"，过滤掉可能残留的"无"（防止之前选中后未清除）
    			this.certificationList = values.filter(item => item !== '无');
			}
			this.ruleForm.student.certification = this.certificationList.join(',');
			this.$refs.ruleFormRef.validateField('student.certification');
		},
		// 处理英语水平等级选择变化
		handleEnglishLevelChange(values) {
			const hasNone = values[values.length-1].includes('未参加或未通过');
			if (hasNone) {
				this.englishLevelList = ['未参加或未通过'];
				this.ruleForm.student.englishLevel4Grade='';
				this.ruleForm.student.englishLevel6Grade='';
			} else {
				// 未选中"无"，过滤掉可能残留的"无"（防止之前选中后未清除）
    			this.englishLevelList = values.filter(item => item !== '未参加或未通过');
			}
			this.ruleForm.student.englishLevel = this.englishLevelList.join(',');
			this.$refs.ruleFormRef.validateField('student.englishLevel');
		},
	}
}
</script>

<style scoped>
/* 带边框的表单样式 */
.bordered-form {
  /* 边框样式 */
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  /* 内边距，让内容与边框有距离 */
  padding: 20px 10px 10px 10px;
  /* 可选：添加轻微阴影增强立体感 */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}
.rongyu{
	text-align: center; 
	height: 70px; 
	line-height: 70px; 
	border: 1px solid #DCDFE6;
	border-radius: 4px;
}
:deep(.el-form-item__label){
	padding: 0 5px 0 0;
}
:deep(.el-divider__text){
	font-weight: bold;
}
:deep(.el-divider--horizontal){
	/* width: 80%;
	margin-left: 10%; */
}
:deep(.el-textarea.is-disabled .el-textarea__inner){
 background-color: white;
 color: black;
}
:deep(.xiayibu .el-form-item__label){
 color: blue;
}
:deep(.xiayibu .el-textarea.is-disabled .el-textarea__inner){
 color: blue;
}
</style>